import React, { useState } from "react";
import Modal from "../common/modal";
import { Helmet } from "react-helmet";
import { paymentService } from "../../services/payment";
import { trackEvent } from '../../utils/tracking';

const DeleteAccountModal = ({ closeModal, history, currentUser }) => {
  const [deleteConfirmation, setDeleteConfirmation] = useState('');
  const [deleteError, setDeleteError] = useState(null);
  const [deleting, setDeleting] = useState(false);

  const hasActiveSubscription = currentUser && currentUser.subscription;
  const canDelete = deleteConfirmation === "delete my account permanently";

  const handleDeleteAccount = () => {
    if (hasActiveSubscription) {
      setDeleteError("You must cancel your subscription first before deleting your account.");
      return;
    }

    setDeleteError(null);
    setDeleting(true);
    paymentService.deleteAccount(
      (response) => {
        trackEvent("AccountDeleted", {});
        alert("Account deleted, goodbye!");
        window.location.href = "https://gummysearch.com";
      },
      (error, response) => {
        setDeleteError(response || "Failed to delete account");
        setDeleting(false);
      }
    );
  };

  return (
    <Modal close={closeModal} widthClass="max-w-md">
      <Helmet><title>Account | Delete Account</title></Helmet>
      
      <div>
        <h3 className="text-lg font-medium leading-6 mb-4">
          Delete Account
        </h3>

        {hasActiveSubscription ? (
          <div className="mb-4">
            <div className="p-3 bg-yellow-900 border border-yellow-700 rounded-md text-yellow-200 text-sm mb-4">
              You cannot delete your account while you have an active subscription. Please cancel your subscription first.
            </div>
            <div className="flex justify-end space-x-3">
              <button
                onClick={closeModal}
                className="px-4 py-2 text-sm font-medium text-gray-300 hover:text-white focus:outline-none"
              >
                Close
              </button>
            </div>
          </div>
        ) : (
          <>
            <p className="text-sm text-gray-400 mb-4">
              This action cannot be undone. This will permanently delete your account and all associated data.
            </p>
            
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-300 mb-2">
                Type "delete my account permanently" to confirm:
              </label>
              <input
                type="text"
                value={deleteConfirmation}
                onChange={(e) => setDeleteConfirmation(e.target.value)}
                className="w-full px-3 py-2 bg-gray-700 border border-gray-600 rounded-md text-white focus:outline-none focus:ring-2 focus:ring-cyan-500 focus:border-transparent"
                placeholder="delete my account permanently"
              />
            </div>

            {deleteError && (
              <div className="mb-4 p-3 bg-red-900 border border-red-700 rounded-md text-red-200 text-sm">
                {deleteError}
              </div>
            )}

            <div className="flex justify-end space-x-3">
              <button
                onClick={closeModal}
                className="px-4 py-2 text-sm font-medium text-gray-300 hover:text-white focus:outline-none"
                disabled={deleting}
              >
                Cancel
              </button>
              <button
                onClick={handleDeleteAccount}
                disabled={!canDelete || deleting}
                className="px-4 py-2 text-sm font-medium text-white bg-red-600 hover:bg-red-700 rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {deleting ? 'Deleting...' : 'Delete Account'}
              </button>
            </div>
          </>
        )}
      </div>
    </Modal>
  );
};

export default DeleteAccountModal;

